export function copyToClipboard(str) {
  const el = document.createElement("textarea");
  el.value = str;
  el.setAttribute("readonly", "");
  el.style.position = "absolute";
  el.style.left = "-9999px";
  document.body.appendChild(el);
  const selection = document.getSelection() || { rangeCount: 0 };
  const selected = selection.rangeCount > 0 ? document.getSelection()?.getRangeAt(0) : false;
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
  if (selected) {
    document.getSelection()?.removeAllRanges();
    document.getSelection()?.addRange(selected);
  }
}
export function interpolate(templateStr, placeholders) {
  return templateStr.replace(/{([^}]+)}/g, function(_, p) {
    return p in placeholders && placeholders[p] ? placeholders[p] : `{${p}}`;
  });
}
export function hash(x) {
  let h, i, l;
  for (h = 5381 | 0, i = 0, l = x.length | 0; i < l; i++) {
    h = (h << 5) + h + x.charCodeAt(i);
  }
  return h >>> 0;
}
export function isColor(color) {
  return !!color.startsWith("#");
}
export function isEmail(str) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);
}
export function isOnlyNumbers(value) {
  return !!value.match(/[0-9\u06F0-\u06F9]/g);
}
export function isProperPhoneLength(value) {
  const sanitized = value.replace(/[- ]/g, "");
  return sanitized.length === 11;
}
export function isPhoneProper(value) {
  if (!value) {
    return false;
  }
  const ACCEPTED_PREFIX = ["010", "011", "012", "015"];
  const sanitized = value.replace(/[- ]/g, "");
  const numericalRe = /^\d+$/g;
  const firstThree = sanitized.substring(0, 3);
  return !!sanitized.match(numericalRe) && ACCEPTED_PREFIX.includes(firstThree);
}
export function isPhone(value) {
  return isPhoneProper(value) && isOnlyNumbers(value) && isProperPhoneLength(value);
}
export function isValidOtp(value) {
  return value.length === 4 && isOnlyNumbers(value);
}
